import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m12 5.386-1.513 3.061a2.5 2.5 0 0 1-1.88 1.367l-3.382.493 2.444 2.378a2.5 2.5 0 0 1 .72 2.215l-.576 3.359 3.024-1.59a2.5 2.5 0 0 1 2.326 0l3.024 1.59-.576-3.36a2.5 2.5 0 0 1 .72-2.214l2.444-2.378-3.382-.493a2.5 2.5 0 0 1-1.88-1.367zm.896-1.572a1 1 0 0 0-1.793 0l-1.96 3.969a1 1 0 0 1-.752.546l-4.385.64a1 1 0 0 0-.553 1.707l3.17 3.084a1 1 0 0 1 .288.886l-.748 4.357a1 1 0 0 0 1.45 1.055l3.922-2.06a1 1 0 0 1 .93 0l3.922 2.06a1 1 0 0 0 1.45-1.055l-.748-4.357a1 1 0 0 1 .288-.886l3.17-3.084a1 1 0 0 0-.553-1.706l-4.384-.64a1 1 0 0 1-.753-.547z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }